/*
 * Conquering Barbell redesign
 * - Find my size dialog (snippets/cb-find-my-size.liquid)
 * - Free shipping progress (snippets/cb-free-shipping.liquid)
 * - Product rail arrows (sections/cb-product-rail.liquid)
 */
(function () {
  'use strict';

  var PROFILE_KEY = 'cb-fit-profile';
  var BUILD_LABELS = { lean: 'a lean', average: 'an average', muscular: 'a muscular', heavy: 'a big & strong' };
  var FIT_LABELS = ['fitted', 'standard', 'loose'];

  function readProfile() {
    try { return JSON.parse(localStorage.getItem(PROFILE_KEY)) || null; } catch (e) { return null; }
  }
  function saveProfile(p) {
    try { localStorage.setItem(PROFILE_KEY, JSON.stringify(p)); } catch (e) {}
  }

  function normSize(s) {
    s = String(s || '').toUpperCase().replace(/\s+/g, '');
    var map = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', '2X': '2XL', '3X': '3XL', '4X': '4XL', SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XLARGE: 'XL' };
    return map[s] || s;
  }

  function fmtHeight(inches, metric) {
    if (metric) return Math.round(inches * 2.54) + ' cm';
    var ft = Math.floor(inches / 12), inch = Math.round(inches - ft * 12);
    if (inch === 12) { ft += 1; inch = 0; }
    return ft + '′' + inch + '″';
  }
  function fmtWeight(lb, metric) {
    return metric ? Math.round(lb / 2.20462) + ' kg' : Math.round(lb) + ' lb';
  }
  function fmtMeasure(inches, unit) {
    if (unit === 'cm') return (Math.round(inches * 2.54 * 10) / 10).toFixed(1);
    var whole = Math.floor(inches), frac = inches - whole;
    var eighths = Math.round(frac * 8);
    var fracs = { 0: '', 1: '⅛', 2: '¼', 3: '⅜', 4: '½', 5: '⅝', 6: '¾', 7: '⅞' };
    if (eighths === 8) { whole += 1; eighths = 0; }
    return whole + fracs[eighths];
  }

  /* Size estimate --------------------------------------------------------- */
  function recommend(chart, profile, available) {
    var h = profile.height, w = profile.weight;
    var chest;
    if (chart.womens) {
      chest = 17 + 0.1 * w - 0.1 * (h - 65) + ({ lean: -1, average: 0, muscular: 1, heavy: 2 })[profile.build];
    } else {
      // Estimated body chest (in). Calibrated so an average build lands in the tee blank's
      // published chest ranges (M 38-41, L 41-44, XL 44-48...). Gains slow above 220 lb.
      chest = 19.6 + 0.12 * Math.min(w, 220) + 0.08 * Math.max(w - 220, 0) - 0.25 * (h - 70) +
        ({ lean: -1.5, average: 0, muscular: 1.5, heavy: 2.5 })[profile.build];
    }
    var ease = chart.ease[profile.fit] || 0;
    var target = (chest + ease) / 2;

    var rows = chart.sizes.filter(function (r) {
      return !available.length || available.indexOf(normSize(r[0])) > -1;
    });
    if (!rows.length) rows = chart.sizes;

    var idx = -1;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i][1] >= target - 0.15) { idx = i; break; }
    }
    var atMax = false, atMin = false;
    if (idx === -1) { idx = rows.length - 1; atMax = true; }
    if (idx === 0 && rows[0][1] - target > 2.5) atMin = true;

    var row = rows[idx];
    var next = rows[idx + 1];
    var note = '';
    if (atMax) {
      note = 'You’re at the top of our size range for this style. Compare with a shirt you own on the Size chart tab.';
    } else if (atMin) {
      note = 'This is our smallest size for this style and may run roomy on you.';
    } else if (!chart.womens && row[2] && row[2] < 0.43 * h - 1.5 && next) {
      note = 'At your height, ' + row[0] + ' may run a little short. For extra length, go up to ' + next[0] + '.';
    }
    return { size: row[0], chest: row[1], note: note };
  }

  /* Find my size ---------------------------------------------------------- */
  function FitFinder(dialog) {
    this.dialog = dialog;
    this.id = dialog.id;
    try {
      this.chart = JSON.parse(dialog.querySelector('[data-cb-fit-chart]').textContent);
    } catch (e) { this.chart = null; }
    if (!this.chart) return;
    this.available = (dialog.dataset.sizes || '').split('|').filter(Boolean).map(normSize);
    this.sizeOption = dialog.dataset.sizeOption || 'Size';
    this.section = dialog.closest('[data-section-id]') || document;
    // Quick view copies the product blocks in and renames ids (…-modal), so find the
    // trigger and hint inside this product rather than by the dialog id.
    this.root = dialog.closest('.product-section') || document;
    this.form = dialog.querySelector('[data-cb-fit-form]');
    this.result = null;
    this.bind();
    this.renderTable('in');
    this.showSavedHint();
  }

  FitFinder.prototype.bind = function () {
    var self = this, d = this.dialog;

    this.root.querySelectorAll('[data-cb-fit-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.open(btn.dataset.cbFitTab); });
    });
    d.querySelectorAll('[data-cb-fit-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });
    d.addEventListener('click', function (e) { if (e.target === d) self.close(); });
    d.addEventListener('close', function () { document.documentElement.classList.remove('cb-lock'); });

    d.querySelectorAll('[data-cb-fit-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () { self.tab(tab.dataset.cbFitTab); });
    });

    this.form.querySelectorAll('input[name="units"]').forEach(function (r) {
      r.addEventListener('change', function () { self.setUnits(r.value); });
    });
    d.querySelectorAll('input[name="chart-units"]').forEach(function (r) {
      r.addEventListener('change', function () { self.renderTable(r.value); });
    });

    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.calculate();
    });

    d.querySelector('[data-cb-fit-apply]').addEventListener('click', function () {
      if (self.result) self.apply(self.result.size);
    });
  };

  FitFinder.prototype.open = function (tab) {
    this.prefill();
    this.tab(tab || 'suggest');
    document.documentElement.classList.add('cb-lock');
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
  };

  FitFinder.prototype.close = function () {
    document.documentElement.classList.remove('cb-lock');
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
  };

  FitFinder.prototype.tab = function (name) {
    this.dialog.querySelectorAll('[data-cb-fit-tab]').forEach(function (t) {
      var on = t.dataset.cbFitTab === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
    });
    this.dialog.querySelectorAll('[data-cb-fit-panel]').forEach(function (p) {
      p.hidden = p.dataset.cbFitPanel !== name;
    });
  };

  FitFinder.prototype.setUnits = function (units) {
    var f = this.form, metric = units === 'metric';
    var h = this.readHeight(!metric), w = parseFloat(f.weight.value);
    f.querySelectorAll('[data-units]').forEach(function (el) { el.hidden = el.dataset.units !== units; });
    this.dialog.querySelector('[data-weight-unit]').textContent = metric ? 'kg' : 'lb';
    f.weight.placeholder = metric ? '90' : '200';
    if (h) this.writeHeight(h, metric);
    if (w) f.weight.value = metric ? Math.round(w / 2.20462) : Math.round(w * 2.20462);
  };

  FitFinder.prototype.readHeight = function (metric) {
    var f = this.form;
    if (metric) {
      var cm = parseFloat(f.cm.value);
      return cm ? cm / 2.54 : 0;
    }
    var ft = parseFloat(f.ft.value) || 0, inch = parseFloat(f['in'].value) || 0;
    return ft || inch ? ft * 12 + inch : 0;
  };

  FitFinder.prototype.writeHeight = function (inches, metric) {
    var f = this.form;
    if (metric) { f.cm.value = Math.round(inches * 2.54); return; }
    var ft = Math.floor(inches / 12), inch = Math.round(inches - ft * 12);
    if (inch === 12) { ft += 1; inch = 0; }
    f.ft.value = ft; f['in'].value = inch;
  };

  FitFinder.prototype.prefill = function () {
    var p = readProfile();
    if (!p || this.form.dataset.prefilled) return;
    this.form.dataset.prefilled = '1';
    var f = this.form;
    var metric = p.units === 'metric';
    f.querySelector('input[name="units"][value="' + (metric ? 'metric' : 'imperial') + '"]').checked = true;
    this.setUnits(metric ? 'metric' : 'imperial');
    this.writeHeight(p.height, metric);
    f.weight.value = metric ? Math.round(p.weight / 2.20462) : Math.round(p.weight);
    var b = f.querySelector('input[name="build"][value="' + p.build + '"]'); if (b) b.checked = true;
    var ft = f.querySelector('input[name="fit"][value="' + p.fit + '"]'); if (ft) ft.checked = true;
  };

  FitFinder.prototype.calculate = function () {
    var f = this.form;
    var metric = f.querySelector('input[name="units"]:checked').value === 'metric';
    var height = this.readHeight(metric);
    var wRaw = parseFloat(f.weight.value);
    var weight = metric ? wRaw * 2.20462 : wRaw;
    var err = this.dialog.querySelector('[data-cb-fit-error]');

    if (!height || height < 54 || height > 90) {
      err.textContent = 'Enter your height (between 4′6″ and 7′6″).';
      err.hidden = false; return;
    }
    if (!weight || weight < 80 || weight > 550) {
      err.textContent = 'Enter your weight (between 80 and 550 lb).';
      err.hidden = false; return;
    }
    err.hidden = true;

    var profile = {
      units: metric ? 'metric' : 'imperial',
      height: height,
      weight: weight,
      build: f.querySelector('input[name="build"]:checked').value,
      fit: parseInt(f.querySelector('input[name="fit"]:checked').value, 10)
    };
    saveProfile(profile);
    this.result = recommend(this.chart, profile, this.available);
    this.showResult(profile);
    this.showSavedHint();
    this.renderTable(this.dialog.querySelector('input[name="chart-units"]:checked').value);
    document.dispatchEvent(new CustomEvent('cb:fit-profile', { detail: profile }));
  };

  FitFinder.prototype.showResult = function (p) {
    var d = this.dialog, r = this.result, metric = p.units === 'metric';
    var box = d.querySelector('[data-cb-fit-result]');
    d.querySelector('[data-cb-fit-size]').textContent = r.size;
    d.querySelector('[data-cb-fit-why]').textContent =
      'Based on ' + fmtHeight(p.height, metric) + ', ' + fmtWeight(p.weight, metric) + ', ' + BUILD_LABELS[p.build] +
      ' build and a ' + FIT_LABELS[p.fit] + ' fit. The ' + this.chart.label + ' in ' + r.size + ' measures ' +
      (metric ? fmtMeasure(r.chest, 'cm') + ' cm' : fmtMeasure(r.chest, 'in') + '″') + ' across the chest.';
    var note = d.querySelector('[data-cb-fit-note]');
    note.textContent = r.note; note.hidden = !r.note;
    d.querySelector('[data-cb-fit-apply]').textContent = 'Select size ' + r.size;
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  FitFinder.prototype.findInput = function (size) {
    var name = this.sizeOption, want = normSize(size);
    var inputs = this.section.querySelectorAll('input[type="radio"][data-variant-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].name === name && normSize(inputs[i].value) === want) return inputs[i];
    }
    return null;
  };

  FitFinder.prototype.apply = function (size) {
    var input = this.findInput(size);
    this.close();
    if (!input) return;
    if (!input.checked) input.click();
    confirmSize(input.closest('[data-cb-size-group]'), input.value);
    var wrap = input.closest('.variant-wrapper');
    if (wrap) {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      wrap.classList.remove('cb-flash');
      void wrap.offsetWidth;
      wrap.classList.add('cb-flash');
    }
  };

  FitFinder.prototype.showSavedHint = function () {
    var p = readProfile();
    var hint = this.root.querySelector('[data-cb-fit-hint]');
    this.section.querySelectorAll('.cb-is-recommended').forEach(function (el) { el.classList.remove('cb-is-recommended'); });
    if (!p || !hint) return;
    var r = recommend(this.chart, p, this.available);
    this.result = this.result || r;
    hint.innerHTML = '';
    hint.appendChild(document.createTextNode('Your recommended size: '));
    var strong = document.createElement('strong'); strong.textContent = r.size; hint.appendChild(strong);
    var edit = document.createElement('button');
    edit.type = 'button'; edit.className = 'cb-fit-hint__edit'; edit.textContent = 'Edit';
    var self = this;
    edit.addEventListener('click', function () { self.open('suggest'); });
    hint.appendChild(edit);
    hint.hidden = false;
    var input = this.findInput(r.size);
    if (input) {
      var label = this.section.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.add('cb-is-recommended');
    }
  };

  FitFinder.prototype.renderTable = function (unit) {
    var c = this.chart, table = this.dialog.querySelector('[data-cb-fit-table]');
    var labelEl = this.dialog.querySelector('[data-cb-fit-chart-label]');
    if (labelEl) labelEl.textContent = c.label + ' — ' + (unit === 'cm' ? 'centimeters' : 'inches');
    var heads = { chest: 'Chest (A)', length: 'Length (B)', sleeve: 'Sleeve' };
    var rec = this.result ? normSize(this.result.size) : null;
    var html = '<thead><tr><th scope="col">Size</th>' + c.fields.map(function (f) {
      return '<th scope="col">' + heads[f] + '</th>';
    }).join('') + '</tr></thead><tbody>';
    var available = this.available;
    c.sizes.forEach(function (row) {
      if (available.length && available.indexOf(normSize(row[0])) === -1) return;
      var cls = rec && normSize(row[0]) === rec ? ' class="is-rec"' : '';
      html += '<tr' + cls + '><th scope="row">' + row[0] + '</th>' + c.fields.map(function (f, i) {
        return '<td>' + fmtMeasure(row[i + 1], unit) + '</td>';
      }).join('') + '</tr>';
    });
    table.innerHTML = html + '</tbody>';
    var sleeve = this.dialog.querySelector('[data-cb-fit-sleeve]');
    if (sleeve) sleeve.hidden = c.fields.indexOf('sleeve') === -1 || c.key === 'raglan';
    var lengthHow = this.dialog.querySelector('[data-cb-fit-length]');
    if (lengthHow && c.lengthHow) lengthHow.textContent = c.lengthHow;
    var source = this.dialog.querySelector('[data-cb-fit-source]');
    if (source) source.textContent = c.note || '';
  };

  function initFit(root) {
    (root || document).querySelectorAll('dialog[data-cb-fit]').forEach(function (d) {
      if (d.dataset.cbReady) return;
      d.dataset.cbReady = '1';
      new FitFinder(d);
    });
  }

  /* Size must be chosen ----------------------------------------------------
     Impulse always pre-selects a size. Until the shopper picks one, the size
     group carries .cb-size-unset (nothing looks selected) and adding to cart
     is stopped with a prompt instead of silently adding the first size. */
  function confirmSize(group, value) {
    if (!group) return;
    group.classList.remove('cb-size-unset');
    var label = group.querySelector('[data-cb-size-value]');
    var checked = group.querySelector('input[type="radio"]:checked');
    if (label) label.textContent = value || (checked && checked.value) || '';
    var err = group.querySelector('[data-cb-size-error]');
    if (err) err.hidden = true;
    var section = group.closest('[data-section-id]');
    if (section) {
      var stickyErr = section.querySelector('[data-cb-sticky-error]');
      if (stickyErr) stickyErr.hidden = true;
    }
    document.dispatchEvent(new CustomEvent('cb:size-confirmed', { detail: { group: group } }));
  }

  function promptSize(group) {
    var err = group.querySelector('[data-cb-size-error]');
    if (err) err.hidden = false;
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    group.classList.remove('cb-flash');
    void group.offsetWidth;
    group.classList.add('cb-flash');
  }

  function sizeGroupForForm(form) {
    // getAttribute: form.id would return the form's <select name="id"> control
    var formId = form.getAttribute('id');
    var input = formId ? document.querySelector('input[data-variant-input][form="' + formId + '"]') : null;
    var scope = (input && input.closest('[data-section-id]')) || form.closest('[data-section-id]');
    return scope ? scope.querySelector('[data-cb-size-group]') : null;
  }

  function onSizePick(e) {
    var input = e.target.closest && e.target.closest('[data-cb-size-group] input[type="radio"]');
    if (input && input.checked) confirmSize(input.closest('[data-cb-size-group]'), input.value);
  }
  document.addEventListener('click', onSizePick);
  document.addEventListener('change', onSizePick);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var group = sizeGroupForForm(form);
    if (group && group.classList.contains('cb-size-unset')) {
      e.preventDefault();
      e.stopPropagation();
      promptSize(group);
    }
  }, true);

  /* Mobile sticky add to cart ------------------------------------------------ */
  function initSticky(root) {
    (root || document).querySelectorAll('[data-cb-sticky]').forEach(function (bar) {
      if (bar.dataset.cbReady) return;
      bar.dataset.cbReady = '1';
      var section = bar.closest('[data-section-id]');
      if (!section) return;
      var mainBtn = section.querySelector('.product-single__meta [data-add-to-cart]');
      var addBtn = bar.querySelector('[data-cb-sticky-add]');
      var priceEl = bar.querySelector('[data-cb-sticky-price]');
      var selEl = bar.querySelector('[data-cb-sticky-selection]');
      var errEl = bar.querySelector('[data-cb-sticky-error]');
      var mq = window.matchMedia('(max-width: 768px)');
      var pastButton = false, footerInView = false;
      if (!mainBtn) return;

      function sync() {
        var main = section.querySelector('.product-single__meta [data-product-price]');
        if (main) priceEl.textContent = main.textContent.trim();
        var group = section.querySelector('[data-cb-size-group]');
        var parts = [];
        section.querySelectorAll('.product-single__meta .variant-wrapper').forEach(function (w) {
          if (w === group) return;
          var c = w.querySelector('input[type="radio"]:checked');
          if (c) parts.push(c.value);
        });
        var unset = group && group.classList.contains('cb-size-unset');
        if (group) {
          var s = group.querySelector('input[type="radio"]:checked');
          parts.push(unset ? 'Choose size' : (s ? s.value : ''));
        }
        selEl.textContent = parts.filter(Boolean).join(' · ');
        selEl.classList.toggle('is-unset', !!unset);
        var soldOut = mainBtn.disabled && !unset;
        addBtn.disabled = soldOut;
        var label = mainBtn.querySelector('[data-add-to-cart-text]');
        addBtn.textContent = soldOut && label ? label.textContent.trim() : (label ? label.dataset.defaultText || 'Add to cart' : 'Add to cart');
      }

      function update() {
        var show = mq.matches && pastButton && !footerInView;
        if (bar.hidden === !show) return;
        bar.hidden = !show;
        document.documentElement.classList.toggle('cb-sticky-on', show);
        if (show) sync();
      }

      new IntersectionObserver(function (entries) {
        var e = entries[0];
        pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      }).observe(mainBtn);

      var footer = document.querySelector('.site-footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerInView = entries[0].isIntersecting;
          update();
        }).observe(footer);
      }
      if (mq.addEventListener) mq.addEventListener('change', update);

      addBtn.addEventListener('click', function () {
        var group = section.querySelector('[data-cb-size-group]');
        if (group && group.classList.contains('cb-size-unset')) {
          errEl.hidden = false;
          promptSize(group);
          return;
        }
        errEl.hidden = true;
        mainBtn.click();
      });

      section.addEventListener('click', function () { setTimeout(sync, 60); });
      document.addEventListener('variant:change', function () { setTimeout(sync, 60); });
      document.addEventListener('cb:size-confirmed', function () { setTimeout(sync, 60); });
      sync();
    });
  }

  /* Open "Find my size" from anywhere (e.g. the fit-help section) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cb-fit-open-any]');
    if (!t) return;
    var btn = document.querySelector('[data-cb-fit-open]');
    if (btn) { e.preventDefault(); btn.click(); }
  });

  /* Free shipping progress ------------------------------------------------ */
  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  // Fill a message template, replacing [amount] with a bold amount (text only, no HTML from settings)
  function fillFreeShipMsg(msg, template, amount) {
    msg.textContent = '';
    (template || '').split('[amount]').forEach(function (part, i) {
      if (i > 0) {
        var strong = document.createElement('strong');
        strong.textContent = amount;
        msg.appendChild(strong);
      }
      if (part) msg.appendChild(document.createTextNode(part));
    });
  }

  function updateFreeShip(cart) {
    document.querySelectorAll('[data-cb-freeship]').forEach(function (el) {
      var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
      var threshold = Math.round(parseInt(el.dataset.threshold, 10) * rate);
      var total = cart ? cart.total_price : 0;
      var left = Math.max(threshold - total, 0);
      var pct = threshold ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
      var msg = el.querySelector('[data-cb-freeship-msg]');
      el.querySelector('[data-cb-freeship-bar]').style.width = pct + '%';
      el.classList.toggle('is-complete', left === 0 && total > 0);
      if (!cart || cart.item_count === 0) {
        fillFreeShipMsg(msg, el.dataset.empty, money(threshold));
      } else if (left > 0) {
        fillFreeShipMsg(msg, el.dataset.progress, money(left));
      } else {
        msg.textContent = el.dataset.success;
      }
      el.hidden = false;
    });
  }

  /* Cart drawer: count, savings, "Add a plate" -------------------------------- */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function updateCartMeta(cart) {
    document.querySelectorAll('[data-cb-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    });
    document.querySelectorAll('[data-cb-cart-saving]').forEach(function (el) {
      var amt = el.querySelector('[data-cb-cart-saving-amount]');
      if (amt) amt.innerHTML = money(cart.total_discount || 0);
      el.hidden = !(cart.total_discount > 0);
    });
  }

  var upsellCache = {};
  function renderUpsell(box, html, cart) {
    var track = box.querySelector('[data-cb-upsell-track]');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inCart = cart.items.map(function (i) { return String(i.product_id); });
    var cards = Array.prototype.slice.call(doc.querySelectorAll('.cb-upsell__card'))
      .filter(function (c) { return inCart.indexOf(c.dataset.productId) === -1; })
      .slice(0, 6);
    track.innerHTML = '';
    cards.forEach(function (c) { track.appendChild(document.importNode(c, true)); });
    box.hidden = cards.length === 0;
  }

  function refreshUpsell(cart) {
    var box = document.querySelector('[data-cb-upsell]');
    if (!box) return;
    if (!cart || !cart.items || !cart.items.length) { box.hidden = true; return; }
    var pid = cart.items[0].product_id;
    if (upsellCache[pid]) { renderUpsell(box, upsellCache[pid], cart); return; }
    fetch(ROOT + 'recommendations/products?section_id=cb-cart-upsell&limit=10&intent=related&product_id=' + pid, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { upsellCache[pid] = html; renderUpsell(box, html, cart); })
      .catch(function () { box.hidden = true; });
  }

  function onCart(cart) {
    if (!cart) return;
    updateFreeShip(cart);
    updateCartMeta(cart);
    refreshUpsell(cart);
  }

  function refreshCart() {
    if (!document.querySelector('[data-cb-freeship], [data-cb-upsell]')) return;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(onCart)
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) onCart(e.detail.cart);
    else refreshCart();
  });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(refreshCart, 400); });
  // Apps that change the cart ask Impulse to rebuild the drawer with cart:build (no cart:updated follows)
  document.addEventListener('cart:build', function () { setTimeout(refreshCart, 400); });

  // Trash icon: remove in place through Impulse's own quantity handler (no page reload)
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-cb-remove]');
    if (!link) return;
    var item = link.closest('.cart__item');
    var input = item && item.querySelector('.js-qty__num');
    if (!input || !link.closest('#CartDrawer')) return;
    e.preventDefault();
    input.value = 0;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // "Add a plate" arrows
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cb-upsell-dir]');
    if (!btn) return;
    var track = btn.closest('[data-cb-upsell]').querySelector('[data-cb-upsell-track]');
    track.scrollBy({ left: parseInt(btn.dataset.cbUpsellDir, 10) * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* Rails ----------------------------------------------------------------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-cb-rail]').forEach(function (rail) {
      if (rail.dataset.cbReady) return;
      rail.dataset.cbReady = '1';
      var track = rail.querySelector('[data-cb-rail-track]');
      if (!track) return;
      rail.querySelectorAll('[data-cb-rail-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.dataset.cbRailDir, 10);
          track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
    });
  }

  /* Worn by lifters: customer videos -----------------------------------------
     Never autoplay. Tapping the still plays the clip with sound and native
     controls; only one clip plays at a time, and it pauses when scrolled away. */
  var ugcObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting && !e.target.paused) e.target.pause();
    });
  }, { threshold: 0.2 }) : null;

  function resetUgcVideo(box) {
    var video = box.querySelector('video');
    box.classList.remove('is-playing');
    if (video) {
      video.pause();
      video.controls = false;
    }
  }

  function initUgcVideos(root) {
    (root || document).querySelectorAll('[data-cb-ugc-video]').forEach(function (box) {
      if (box.dataset.cbReady) return;
      box.dataset.cbReady = '1';
      var video = box.querySelector('video');
      var btn = box.querySelector('[data-cb-ugc-play]');
      if (!video || !btn) return;

      btn.addEventListener('click', function () {
        box.classList.add('is-playing');
        video.controls = true;
        video.muted = false;
        var playing = video.play();
        if (playing && typeof playing.catch === 'function') {
          playing.catch(function () { resetUgcVideo(box); });
        }
        try { video.focus({ preventScroll: true }); } catch (e) {}
      });

      // Starting one clip pauses any other
      video.addEventListener('play', function () {
        document.querySelectorAll('[data-cb-ugc-video] video').forEach(function (other) {
          if (other !== video && !other.paused) other.pause();
        });
      });

      // Back to the still when the clip finishes
      video.addEventListener('ended', function () {
        resetUgcVideo(box);
        video.currentTime = 0;
      });

      if (ugcObserver) ugcObserver.observe(video);
    });
  }

  function init(root) {
    initFit(root);
    initRails(root);
    initSticky(root);
    initUgcVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); refreshCart(); });
  } else {
    init(); refreshCart();
  }
  document.addEventListener('quickview:loaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); refreshCart(); });
})();
